/**
 * Row status after a cancel (ZLAYT-1603).
 *
 * Cancelling a rerun of a finished report, deposition summary or demand
 * letter leaves the finished version as the current one, so the server then
 * reports Completed. The table keeps a cancelled row on "Draft" only while
 * the server still reports the run as going (a stale Pending); otherwise it
 * shows what the server says.
 */
const RUNNING_STATUSES = new Set(['pending', 'in progress', 'in_progress']);

export function cancelledRowStatus(serverStatus?: string | null): string {
  const value = String(serverStatus ?? '').trim();
  return RUNNING_STATUSES.has(value.toLowerCase()) ? 'Draft' : value;
}

/**
 * True when a socket status update should refetch the list: a row that
 * newly failed needs its failure reason, and a cancelled one needs the
 * status of the version that is current again.
 */
export function refetchAfterStatus(
  rawStatus: string | null | undefined,
  previousStatus: string | null | undefined
): boolean {
  const value = String(rawStatus ?? '').toLowerCase();
  if (value.includes('cancel')) return true;
  return value.includes('fail') && previousStatus !== 'Failed';
}
